import { IndexDbService } from "./indexDbService";
import { isImagePatternMember } from '@/utils/imagePatternMasks';
import { sharedPatternImage } from '@/utils/imagePatternImages';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TestImageService', testImageService);

    const indexDbService = new IndexDbService();

    function testImageService($q, $rootScope) {
        function previewImageOnPlaceholder(file, canvas, placeHolderId, isFromStep2 = false, isPlaceholder = false, firstStepPlaceholder = null) {
            return $q(function (resolve, _) {
                if (!file) return resolve();
                // Read the file
                const fr = new FileReader();
                fr.onload = function () {
                    //we have to iterate over the entire array to cover those cases in which there are multiple images
                    //with the same ID's
                    const objects = canvas.getObjects().filter(
                        o => o.type === 'image-placeholder' && o.id === placeHolderId
                    );
                    const saveTestingValue = (canvasObject, src) => {
                        canvasObject.testingUrl = src;
                        if (
                            !$rootScope?.user?.AccessRoles?.Serialized?.split(',')?.includes(
                                'skip-save-testing-values'
                            )
                        ) {
                            indexDbService.findAndEditValue(canvasObject.uuid, fr.result, $rootScope);
                        }
                        if (isPlaceholder && isFromStep2 && firstStepPlaceholder) firstStepPlaceholder.testingUrl = src;
                    };

                    const patternMembers = objects.filter((o) => isImagePatternMember(o));
                    if (patternMembers.length) {
                        const { image, loaded } = sharedPatternImage(fr.result);
                        for (const member of patternMembers) saveTestingValue(member, image.src);
                        loaded.then(() => {
                            for (const member of patternMembers) member.setElement(image);
                            canvas.renderAll();
                            resolve();
                        }, () => undefined);
                    }

                    for (const object of objects) {
                        if (isImagePatternMember(object)) continue;
                        (function (canvasObject) {
                            const imgAux = document.createElement('img');
                            imgAux.onload = function () {
                                canvasObject.setElement(imgAux);
                                canvas.renderAll();
                                resolve();
                            };
                            imgAux.src = fr.result;
                            saveTestingValue(canvasObject, imgAux.src);
                        })(object);
                    }
                };
                fr.readAsDataURL(file);
            });
        }

        function showStaticImage(canvas, imgPlaceholder, imageProperties) {
            if (isImagePatternMember(imgPlaceholder) && imageProperties.imageUrl) {
                const { image, loaded } = sharedPatternImage(imageProperties.imageUrl);
                loaded.then(() => {
                    imgPlaceholder.setElement(image);
                    // The whole pattern resolves in the same tick: one render for all of them
                    canvas.requestRenderAll();
                }, () => undefined);
                return;
            }
            const imgAux = document.createElement('img');
            imgAux.onload = function () {
                imgPlaceholder.setElement(imgAux);
                canvas.renderAll();
            };
            imgAux.setAttribute('crossOrigin', 'anonymous');
            imgAux.src = imageProperties.imageUrl;
        }

        function showStaticImageSvg(canvas, imgPlaceholder, imageProperties) {
            fetch(imageProperties.imageUrl)
                .then((response) => response.text())
                .then(async (text) => {
                    imgPlaceholder.set('svgString', text);
                    // For vector-placeholder targets, the control rectangle/init position are
                    //  reapplied asynchronously once the SVG finishes loading (see
                    //  fabric.VectorPlaceholder._set) - render before this resolves and the canvas
                    //  paints the placeholder mid-reset instead of its saved position. Harmless
                    //  no-op for other placeholder types, which don't set this property.
                    await imgPlaceholder._contentLoadPromise;
                    canvas.requestRenderAll();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        return {
            previewImageOnPlaceholder: previewImageOnPlaceholder,
            showStaticImage: showStaticImage,
            showStaticImageSvg: showStaticImageSvg
        };
    }
})();
